// M3 economy & politics selectors (pure reads) for sim/selectors.js.
import { netback, opexPerWell } from '../production.js';
import { yf } from '../defs.js';
import { fiscalView as fv } from './fiscal.js';
import { realizedDiscount, POSTED_PRICE_REGIONS, US_PRICE_CONTROLS, usPriceMult, suezOpen } from '../../data/m3/rules.js';
import { flagOn } from '../m2util.js';
import { spotPrice } from '../../economy/market.js';
export { leaseRoundView, concessionView } from './leaserounds.js';
export { hedgeView } from './hedging.js';
export { routeView } from './routes.js';
export { regimeView } from './regimes.js';
export { nationalizationView } from './nationalize.js';

export const fiscalView = (state, fieldId) => fv(state, fieldId, netback, opexPerWell(yf(state)));

// OPEC & the price regime at a glance (posted vs realized, controls, flags).
export function opecView(state) {
  const y = yf(state);
  const posted = spotPrice(state);
  const d = realizedDiscount(y);
  return {
    year: y, posted, realized: posted * (1 - d), discount: d, postedRegions: POSTED_PRICE_REGIONS,
    opec: flagOn(state, 'opec'), tehranAgreement: flagOn(state, 'tehranAgreement'), arabEmbargo: flagOn(state, 'arabEmbargo'),
    embargoes: (state.m3econ?.embargoes ?? []).filter((e) => state.day < e.untilDay).map((e) => ({ ...e })),
    usPriceMult: usPriceMult(y), usControls: y >= US_PRICE_CONTROLS.from && y < US_PRICE_CONTROLS.until, suezOpen: suezOpen(y),
    nymexFutures: flagOn(state, 'nymexFutures') || y >= 1983.25,
  };
}
